<template>
  <div v-if="lastPage > 1">
    <div class="d-flex justify-content-center">
      <CButton
        color="secondary"
        variant="outline"
        :disabled="!canPrev()"
        class="mr-1 page_item_link"
        @click.prevent="prev"
      >
        &#60;
      </CButton>

      <CButton
        v-for="page_option in getPageOptions()"
        :key="page_option"
        class="mx-1 page_item_link"
        :variant="currentPage === page_option ? undefined : 'outline'"
        :disabled="loading"
        :color="currentPage === page_option ? 'primary' : 'secondary'"
        @click.prevent="goTo(page_option)"
      >
        {{ page_option }}
      </CButton>

      <CButton
        color="secondary"
        variant="outline"
        :disabled="!canNext()"
        class="ml-1 page_item_link"
        @click.prevent="next"
      >
        &#62;
      </CButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    lastPage: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    canPrev() {
      return !this.loading && this.canGoTo(this.currentPage - 1);
    },

    canNext() {
      return !this.loading && this.canGoTo(this.currentPage + 1);
    },

    next() {
      this.goTo(this.currentPage + 1);
    },

    prev() {
      this.goTo(this.currentPage - 1);
    },

    first() {
      this.goTo(1);
    },

    last() {
      this.goTo(this.lastPage);
    },

    canGoTo(page) {
      return page <= this.lastPage && page >= 1 && !this.loading;
    },

    goTo(page) {
      if (page > this.lastPage) page = this.lastPage;
      if (page < 1) page = 1;
      this.$emit('paginate', page);
    },

    getPageOptions() {
      let pages = [];
      let page = parseInt(this.currentPage);
      if (this.currentPage === 1) {
        pages.push(page);
        if (this.lastPage > 1) pages.push(page + 1);
        if (this.lastPage > 2) pages.push(page + 2);
      } else if (this.currentPage === this.lastPage) {
        if (this.lastPage > 2) pages.push(page - 2);
        if (this.lastPage > 1) pages.push(page - 1);
        pages.push(page);
      } else {
        pages.push(page - 1);
        pages.push(page);
        pages.push(page + 1);
      }
      // Filtrar valores fuera de rango por si acaso
      return pages.filter((p) => p >= 1 && p <= this.lastPage);
    },
  },
};
</script>

<style>
.page_item_link {
  min-width: 35px;
  white-space: nowrap;
  text-align: center;
}
</style>
